import { required } from 'vuelidate/lib/validators'

export default {
  to: {
    agenda_id: {
      required
    },
    schedule_id: {
      required
    }
  },
  date: {
    required
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/schedulings/components/transfer/resources/validations.js